import moment from 'moment';

export const getIn5MinDate = () => {
  return new Date(moment().add(5, 'minutes').format());
};
